import { useEffect, useState } from "react";
import { axiosPrivate } from "../../api/axios";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
/**
 * useGetProviderInfo() - Gets the authorize url and stripe publishable key if the company uses stripe
 * @returns
 */
export const useGetProviderInfo = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const [error, setError] = useState();
    const { datadogLog } = useLogging();
    useEffect(() => {
        setLoading(true);
        axiosPrivate
            .get(`/React/GetPaymentProviderInfo`)
            .then((res) => {
            if (!res.data.success) {
                datadogLog(res.data.responseMsg, LogLevel.ERROR, res);
                setError("Something unexpected happened while loading the page. Code: BI1");
                return;
            }
            setError(undefined);
            setData(res.data);
        })
            .catch((e) => {
            datadogLog(e.message, LogLevel.ERROR, {}, e);
            setData(undefined);
            setError(`Something unexpected happened while loading the page. Code: BI2`);
        })
            .then(() => setLoading(false));
    }, []);
    return { loading, data, error };
};
